import { useContext, useEffect, useState } from "react"
import { UserContext } from "../../context/UserContext"
import useSession from "../../hooks/useSession";

const Footer = () => {
  const [session] = useSession();
  const { user, getL10nInstance } = useContext(UserContext)

  const [l10n, setL10n] = useState(null)

  useEffect(() => {
    (async () => {
      const instance = await getL10nInstance()
      setL10n(instance)
    })()
  }, [session, user])

  return (
    <div style={{textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '1.5rem'}}>
        <div style={{fontWeight: '600', color: '#A7A9B3', marginRight: '0.5rem'}}>{l10n && l10n.getString('Powered by')}</div>
        <img alt="bunny-logo" style={{height: '24px'}} src="https://d8ia9pq8hp3tl.cloudfront.net/img/widget-footer-logo.png"/>
    </div>
  )
}

export default Footer